<template>
  <modal
    v-slot="{ data }"
    name="offerDetails"
    modal-style="compact"
  >
    <offer-details :data="data" />
  </modal>
</template>


<script>
  import OfferDetails from './offer-details/index.vue';


  export default {
    name: 'OfferDetailsModal',

    components: {
      OfferDetails
    }
  };
</script>
